/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { useEffect } from 'react';
import { pkg } from '../../../settings';
export var useResetSpreadsheetFocus = function useResetSpreadsheetFocus(_ref) {
  var _ref$blockClass = _ref.blockClass,
      blockClass = _ref$blockClass === void 0 ? "".concat(pkg.prefix, "--data-spreadsheet") : _ref$blockClass,
      focusedElement = _ref.focusedElement,
      removeActiveCell = _ref.removeActiveCell,
      setContainerHasFocus = _ref.setContainerHasFocus;
  // Reset everything when spreadsheet loses focus
  useEffect(function () {
    if (!focusedElement.classList.contains("".concat(blockClass, "--interactive-cell-element"))) {
      setContainerHasFocus(false);
      removeActiveCell();
    }

    if (focusedElement.classList.contains(blockClass) || focusedElement.classList.contains("".concat(blockClass, "--interactive-cell-element"))) {
      setContainerHasFocus(true);
    }
  }, [focusedElement, removeActiveCell, blockClass, setContainerHasFocus]);
};